import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { DialogService } from '@mode/shared/ui';

@Component({
  selector: 'mode-plan-downgrade',
  templateUrl: './plan-downgrade.component.html',
  styleUrls: ['./plan-downgrade.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlanDowngradeComponent {
  errorTitle = 'Welcome to Mode Free';
  errorInstructions =
    'Your subscription has changed to Mode Free, but there are options! Continue to use Mode Free or work with a specialist to upgrade.';
  errorPrimaryActionLabel = 'Upgrade now';
  errorSecondaryActionLabel = 'Continue with Free';
  numberOfSeats = 3;
  planTitle = '';

  constructor(private dialogService: DialogService) {}
  @Input()
  hasNoSecondary!: boolean;

  @Input()
  paidPlan!: boolean;

  closeModal() {
    this.dialogService.closeAll();
  }
}
